import React from 'react';
import { Block, FlexBox, IconCheckCircleClientReview, TextCommon } from '@esg/ui';
import { Card } from 'antd';
import { translateCodes } from '@/locales';
export function SuccessReview() {
  return (
    <Block width={500}>
      <Card >
        <FlexBox direction={'column'} gap={15} alignItems='center'>
          <IconCheckCircleClientReview />
          <FlexBox direction='column' alignItems='center'>
            <TextCommon fontWeight={700} fontSize={24} translateCode={translateCodes.THANK_FOR_FEEDBACK} />
            <TextCommon textAlign='center' fontSize={16} translateCode={translateCodes.FEEDBACK_RECEIVED} />
          </FlexBox>
        </FlexBox>
      </Card>
    </Block>
  );
}
